require('./style.scss')
angular = require('angular')
pkg = angular
  .module 'common.editor', []
  .service 'editor', require('./modal')
  .directive 'editorFields', require('./fields')
  .directive 'isoDate', require('./fields/iso')
     
module.exports = pkg.name


// WEBPACK FOOTER //
// ./src/common/editor/index.coffee